<template>
  <div style="padding-left: 10px">
    <el-row class="search-box">
      <el-input v-model.trim="product_sn" placeholder="请扫SN码" @keyup.enter="search" class="input"></el-input>
      <el-button :loading="loading" @click="search">查询</el-button>
      <KfMessage ref="searchMessage"/>
    </el-row>
    <StationInfo ref="info" :bu-item="buItem"></StationInfo>

    <div style="margin: 10px 0 0 8px" v-if="showForm">
      <FrameForm ref="frameForm" :component-param="componentParam"
                 :parent-data="buItem"></FrameForm>
    </div>
  </div>
</template>

<script>

import StationInfo from "@/views/applications/station/StationInfo.vue";

export default {
  name: "StationParent",
  components: { StationInfo},
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      product_sn: '',
      in_logistics_no: '',
      canWork: false,
      loading: false,
      buItem: {},
      imageList: [],
      showForm:true,
      showTestNg:false,
      testNgInfo:{},
    }
  },
  computed: {
    stationId() {
      if (this.componentParam && this.componentParam.length > 8) {
        return this.componentParam.substring(8);
      }
      return '';
    }
  },
  provide() {
    return {
      $fn: {
        reset: () => {
          this.product_sn = ''
          this.reset();
        }
      }
    }
  },
  methods: {
    async search() {
      this.reset()

      this.$refs.frameForm.formInfo = {} //清空作业表单内容
      this.$refs.frameForm.clearMessage()
      if (this.$refs.frameForm.reset) {
        this.$refs.frameForm.reset()
      }

      this.showForm = false

      if (!this.product_sn) {
        this.showForm = true
        return this.$refs.searchMessage.showError('SN码不能为空')
      }

      this.loading = true
      this.$http('repairService.queryStationInfo', {
        station_id: this.stationId,
        product_sn: this.product_sn
      }, false).then(async data => {
        this.loading = false
        this.buItem = data.buItem || {}
        this.buItem.station_id = this.stationId
        this.imageList = data.imageList
        this.canWork = true
        this.showForm = true
        this.$refs.info.setButtonData(this.buItem.id);
        // await this.$refs.frameForm.initForm()
        return this.$refs.searchMessage.showSuccess('状态正常，请作业');
      }, errMsg => {
        this.loading = false
        this.showForm = true
        return this.$refs.searchMessage.showError(errMsg)
      })

    },
    reset() {
      this.buItem = {}
      this.canWork = false
      this.$refs.searchMessage.clear()

    },


  }
}
</script>

<style scoped>
.input {
  height: 32px;
  width: 250px;
  margin-right: 10px;
}

.search-box {
  padding-top: 10px;
  line-height: 40px;
  min-height: 50px;
}

.item-text {
  text-align: right;
}

.login-user {
  position: absolute;
  right: 10px;
}
</style>